import ExpenseSection from './ExpenseSection';

export default ExpenseSection;
